module.exports = __webpack_public_path__ + "img/Avatar.b5ffcda1.png";